import type { TBool, TSerial, TRawLevelOptions, IBaseRawLevelOption } from './common'

export enum ELevelOptionType {
  Regular = 1,
  Special = 2
}

export interface IAncientLevelOption {
  readonly optionKey: string
  readonly optionValue: string
}

export type TAncientLevelOptions = readonly IAncientLevelOption[]

export interface IAdvancedAncientLevelOption extends IAncientLevelOption {
  readonly serial: TSerial
  readonly transKey: string
}

export type TAdvancedAncientLevelOptions = readonly IAdvancedAncientLevelOption[]

interface IBaseLevelOption {
  readonly appId: number
  readonly optionKey: string
  readonly optionValue: string
}

interface ITypedBaseLevelOption extends IBaseLevelOption {
  readonly type: ELevelOptionType
}

export interface INewLevelOption extends ITypedBaseLevelOption {
  readonly custom?: string
  readonly transKey?: string
  readonly titleTransKey?: string
}

export type TNewLevelOptions = readonly INewLevelOption[]

export interface IGetLevelOption extends IBaseLevelOption {
  readonly custom: string | undefined
  readonly transKey: string | undefined
  readonly titleTransKey: string | undefined
}

export interface ILevelOption extends ITypedBaseLevelOption {
  readonly id: number
  readonly createdAt: string
  readonly custom: string | null
  readonly transKey: string | null
  readonly titleTransKey: string | null
  readonly isPrimary: TBool
}

export type TLevelOptions = readonly ILevelOption[]

export interface ILevelOptionWithModuleId extends ILevelOption {
  readonly moduleId: number
}

export type TBaseRawLevelOptions = readonly IBaseRawLevelOption[]

export interface IGetTranslatedLevelOptionsByParams {
  readonly type?: ELevelOptionType
}

export interface IAdvLevelOption extends ILevelOption {
  readonly canBePrimary: boolean
}

export type TAdvLevelOptions = readonly IAdvLevelOption[]

export interface IGetLevelOptionsByAppIdResponse {
  readonly levelOptions: TAdvLevelOptions
}

export interface IGetResourceStringsResponse {
  readonly levelOptions: readonly string[]
}

/** Ez az interface az Ügyesedni appokhoz kell, hogy szériaszám és module azonosító alapján elkérjük a hozzátartozó modult. */
export interface IGetLevelOptionsBySerialAndModuleIdRequest {
  readonly moduleId: number
  readonly serial: TSerial
}

export interface IGetLevelOptionsBySerialAndModuleIdResponse {
  readonly levelOptions: TLevelOptions
}

export interface IGetLevelOptionByIdRequest {
  readonly id: number
}

export interface IGetLevelOptionByIdResponse {
  readonly levelOption: ILevelOption
}

export interface IUpdateLevelOption {
  readonly id: number
  readonly key: string
  readonly value: string
  readonly custom: string

}

export interface IUpdateLevelOptionRequest extends IUpdateLevelOption {
  readonly isPrimary: TBool
}

interface IActiveLevelOption extends IAncientLevelOption {
  readonly transKey: string
}

export type TActiveLevelOptions = readonly IActiveLevelOption[]

export interface IGetActiveLevelOptionsBySerialResponse {
  readonly levelOptions: TActiveLevelOptions
}

// --

export interface IBaseActiveLevelOption extends IAncientLevelOption {
  readonly transKey: string | null
}

export type TBaseActiveLevelOptions = readonly IBaseActiveLevelOption[]

interface IActiveLevelOptionBySerial extends IBaseActiveLevelOption {
  readonly moduleId: number
}

export type TActiveLevelOptionsBySerial = readonly IActiveLevelOptionBySerial[]

export interface IGetLevelOptionCombinationsBySerialResponse {
  readonly combinations: readonly TBaseActiveLevelOptions[]
}

export interface ITranslatedLevelOption extends ILevelOption {
  readonly text: string | null
  readonly title: string | null
}

export type TTranslatedLevelOptions = readonly ITranslatedLevelOption[]

export interface ILevelOptionsData {
  readonly deletableLevelOptions: TLevelOptions
  readonly newLevelOptions: TRawLevelOptions
}

export interface IGetModuleIdByAncientLevelOptionsRequest {
  readonly levelOptions: TAdvancedAncientLevelOptions
}

export interface IGetModuleIdByAncientLevelOptionsResponse {
  readonly moduleId: number
}

export interface IGetPossibleModuleBySerialAndLevelOptionsRequest {
  readonly optionKeys: string[]
  readonly optionValues: (string | number)[]
}

export interface IModularInitResponse {
  /** Azon szintopciók tömbje, amelyeket tartalmaz az adott modul. */
  readonly levelOptionsToInclude: TLevelOptions
  /** Azon elsődleges szintopciókból előálló sztringek (wháááh) tömbje, amelyeket nem kell erőforrásként behúzni. */
  readonly levelOptionsToSkip: readonly string[]

}
